import React from 'react'

interface Props {
  width?: number | string
  height?: number | string
  className?: string
}

export const IconHP = React.memo(({ width, height, className }: Props) => (
  <svg
    className={className || ''}
    viewBox="0 0 30 30"
    width={width}
    height={height}
    fill="currentColor"
  >
    <rect width="100%" height="100%" fill="none" />
    <path
      fill="currentColor"
      d="M24.1 10.4h-2.4l-3.3 9.2h2.4l3.3-9.2zM15 30h-.4l3.1-8.4h4.2c.7 0 1.6-.6 1.8-1.3l3.3-9.1c.5-1.5-.3-2.7-1.9-2.7h-5.9L14.3 22l-2.8 7.6C4.9 28 0 22.1 0 15 0 8.1 4.6 2.3 11 .6L8.1 8.4 3.3 21.6h3.2l4.1-11.1H13L8.9 21.6h3.2l3.8-10.4c.5-1.5-.3-2.7-1.9-2.7h-2.7l3-8.5h.7c8.3 0 15 6.7 15 15s-6.7 15-15 15z"
    />
  </svg>
))
